import { render } from "./LearningPlansPage.vue?vue&type=template&id=d5454512"
import script from "./LearningPlansPage.vue?vue&type=script&lang=js"
export * from "./LearningPlansPage.vue?vue&type=script&lang=js"

import "./LearningPlansPage.vue?vue&type=style&index=0&id=d5454512&lang=sass"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__